export const Notification = {

  init () {
    if (undefined !== window.CI && undefined !== window.CI.notification) {
      $$.notification.parse(CI.notification);
    }
  },

  parse (objMessage) {
    if (objMessage !== null && objMessage !== undefined) {
      let keys = Object.keys(objMessage);
      for (let a1 = 0, b1 = keys.length; a1 < b1; a1 += 1) {
        let c1 = keys[a1];
        for (let a2 = 0, b2 = objMessage[c1].length; a2 < b2; a2 += 1) {
          let c2 = objMessage[c1][a2];
          $$.notification.show(c1, c2);
        }
      }
    }
  },

  show (type, message) {
    let toast;
    let now = new Date();
    let id = 'divToast-' + now.toISOString();
    let types = {
      error: {
        icon: 'bi-exclamation-octagon',
        bgColor: 'bg-danger bg-opacity-50',
        textColor: 'text-danger',
        title: 'Erro'
      },
      erro: {
        icon: 'bi-exclamation-octagon',
        bgColor: 'bg-danger bg-opacity-50',
        textColor: 'text-danger',
        title: 'Erro'
      },
      warning: {
        icon: 'bi-exclamation-triangle',
        bgColor: 'bg-warning bg-opacity-50',
        textColor: 'text-warning',
        title: 'Alerta'
      },
      aviso: {
        icon: 'bi-exclamation-triangle',
        bgColor: 'bg-warning bg-opacity-50',
        textColor: 'text-warning',
        title: 'Alerta'
      },
      information: {
        icon: 'bi-exclamation-square',
        bgColor: 'bg-info bg-opacity-50',
        textColor: 'text-info',
        title: 'Informação'
      },
      informacao: {
        icon: 'bi-exclamation-square',
        bgColor: 'bg-info bg-opacity-50',
        textColor: 'text-info',
        title: 'Informação'
      },
      success: {
        icon: 'bi-exclamation-circle',
        bgColor: 'bg-success bg-opacity-50',
        textColor: 'text-success',
        title: 'Sucesso'
      },
      sucesso: {
        icon: 'bi-exclamation-circle',
        bgColor: 'bg-success bg-opacity-50',
        textColor: 'text-success',
        title: 'Sucesso'
      }
    };
    if (types[type] !== undefined) {
      let divToast = $('<div>', {
        id: id,
        class: 'toast ' + types[type].bgColor,
        role: 'alert',
        'aria-live': 'assertive',
        'aria-atomic': true
      }).append(
        $('<div>', {
          class: 'toast-header'
        }).append(
          $('<strong>', {
            class: 'me-auto'
          }).append(
            $('<i>', {
              class: types[type].icon + ' ' +  types[type].textColor
            })
          ).append(' ').append(
            types[type].title
          )
        ).append(
          $('<button>', {
            type: 'button',
            class: 'btn-close',
            'data-bs-dismiss': 'toast',
            'aria-label': 'Fechar'
          })
        )
      ).append(
        $('<div>', {
          class: 'toast-body'
        }).append(
          message
        )
      );
      $('#divToastContainer').append(divToast);
      toast = new bootstrap.Toast(document.getElementById(id));
      toast.show();
    } else {
      alert(message);
    }
  },

};